<template>
  <div class="Box mx-2 pt-2 pb-2" dir="">
      <div class="row mt-2">
        <div class="col-md-1 text-center col-12">
          <slot name="Pnl-r1"> </slot>
        </div>
        <div class="col-md-3 mt-2 text-center col-12">
          <slot name="Pnl-r2"> </slot>
        </div>
        <div class="col-md-4 mt-2 text-right col-12">
          <slot name="Pnl-r3"> </slot>
        </div>
        <div class="col-md-4 mt-2 text-right col-12">
          <slot name="Pnl-r4"> </slot>
        </div>
        
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style scoped>
.Box {
  font-size: 18px;
  border-radius: 5px;
  /* border-right: 3px solid #eb9900; */
  border-right: 4px solid var(--logo-color);
  border-top: 1px solid rgba(145, 145, 145, 0.514);
  border-bottom: 1px solid rgba(145, 145, 145, 0.514);
  border-left: 1px solid rgba(145, 145, 145, 0.514);
}
.border-left{
  border-left:1px dashed var(--logo-color) !important;
}
.text-dark-light {
  color: rgb(126, 126, 126);
  font-size: 16px !important;
}
.text-dark {
  white-space: nowrap;
  font-size: 16px !important;
}
</style>
